// login.component.ts

import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';

import { AuthService } from '../../_service/auth.service';
import { UserSettingsService } from '../../_service/user-settings.service';
import { DataService } from '../../_service/data.service';
import { SyncCoordinatorService } from '../../_service/sync/sync-coordinator.service';
import { DataTargetService } from '../../_service/data-target.service';
import { SpaceContextService } from '../../_service/space-context.service';
import { SpaceDirectoryService } from '../../_service/space-directory.service';
import { DATA_TARGETS } from '../../_util/data-target';
import { getClientEnv } from '../../_util/environment-info';


@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'], // Optional: Include if you have styles
    imports: [CommonModule, FormsModule, RouterModule]
})



export class LoginComponent implements AfterViewInit{
    @ViewChild('usernameInput') usernameInput!: ElementRef;

  username: string = '';
  password: string = '';
  errorMessage: string = '';
  loading: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private userSettingsService: UserSettingsService,
    private dataService: DataService,
    private syncCoordinator: SyncCoordinatorService,
    public dataTarget: DataTargetService,
    private titleService: Title,
    private spaceContext: SpaceContextService,
    private spaceDirectory: SpaceDirectoryService,
  ) { }

  readonly dataTargets = DATA_TARGETS;
  readonly clientEnv = getClientEnv();


  ngAfterViewInit(): void {
    this.titleService.setTitle('Login');
    this.userSettingsService.loadSavedTheme();
    this.usernameInput.nativeElement.focus();
  }


  /**
   * Handles the login process by calling the AuthService login method.
   * Navigates to the home page upon successful login.
   */
  onLogin(): void {
    console.log("in onLogin()");

    this.loading = true;
    this.authService.login(this.username, this.password).subscribe(
      async response => {
        this.loading = false;
        // The token (and therefore the authenticated account) is now current —
        // switch to that account's own IndexedDB database and reset any
        // sync bookkeeping cached from a previous account's session.
        this.syncCoordinator.onAccountChanged();
        await this.dataService.initialize();
        // Sync right away (offline-first: don't hold up navigation on the network).
        void this.syncCoordinator.syncAfterLogin().catch(err => console.error('Post-login sync failed', err));
        // A different account can belong to different Spaces — refresh which one is active.
        void this.spaceContext.initialize();
        // ...and refresh the account-scoped Space name directory (tasks/space_ux.md) too, so a
        // stale/empty prior-account cache never briefly shows through before this account's own
        // Spaces load.
        this.spaceDirectory.loadCached();
        this.spaceDirectory.refresh();
        // Navigate to the home page
        this.router.navigate(['/home']);
      },
      error => {
        this.loading = false;
        // Display error message
        // this.errorMessage = error;
        this.setErrorMessage(error);
      }
    );
  }


  /**
   * Sets a user-friendly error message based on the error response.
   * @param error The error response from the login attempt.
   */
  private setErrorMessage(error: any): void {
    console.error('In login.component.ts: setErrorMessage() : ', error); // Log the entire error object
    this.errorMessage = error;
    // const status = error.response?.status || error.status;
    // if (status === 401) {
    //   this.errorMessage = 'Invalid username or password. Please try again.';
    // } else if (status === 0) {
    //   this.errorMessage = 'Unable to connect to the server. Please check your internet connection.';
    // } else {
    //   this.errorMessage = 'An unexpected error occurred. Please try again later.';
    // }
  }



}